'use client';

/**
 * Project Graph Widget
 *
 * @component_role Project Relationship Visualization
 * @business_rule Displays project procurement hierarchy (Project → RFQs → POs → Vendors)
 *   as an interactive WebGL graph using Reagraph.
 * @user_outcome Understand project structure at a glance - see all RFQs, purchase orders,
 *   and vendor relationships for a project in a visual network.
 * @integration_point klyde_edge /neo/graph/visualize/project - retrieves graph nodes/edges from Neo4j
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain procurement_intelligence
 */

import { ProjectGraphReagraph } from './project-graph-reagraph';

interface ProjectGraphCompareProps {
  /** Standard prop from registry */
  entityId?: string;
  /** Standard prop from registry */
  title?: string;
  /** @deprecated Use entityId */
  projectId?: string;
  /** @deprecated Use title */
  projectName?: string;
  depth?: number;
}

export function ProjectGraphCompare({
  entityId,
  title,
  projectId: legacyProjectId,
  projectName: legacyProjectName,
  depth = 2,
}: ProjectGraphCompareProps) {
  // Support both standard and legacy props
  const projectId = entityId ?? legacyProjectId ?? '';
  const projectName = title ?? legacyProjectName;

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 min-h-0">
        <ProjectGraphReagraph
          projectId={projectId}
          projectName={projectName}
          depth={depth}
        />
      </div>
    </div>
  );
}
